import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { RESTAURANT } from "../lib/api";

export default function AnnouncementBar() {
  return (
    <div
      data-testid="announcement-bar"
      className="fixed top-0 left-0 right-0 z-[60] bg-[#1C2219] border-b border-[#2E3628] text-[#F9F6F0] py-2.5 px-4 text-center text-[11px] tracking-[0.2em] uppercase"
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-center gap-3">
        <Sparkles className="w-3 h-3 text-[#D4C1A0]" strokeWidth={1.4} />
        <span className="text-[#9AA894]">
          <span className="text-[#D4C1A0]">{RESTAURANT.offerPercent}%</span>{" "}
          off all dining when you reserve through chica.com
        </span>
        <Link
          to="/reserve"
          data-testid="announcement-cta"
          className="hidden md:inline text-[#D4C1A0] hover:text-[#F9F6F0] underline-offset-4 hover:underline"
        >
          Reserve →
        </Link>
      </div>
    </div>
  );
}
